import React, { useState } from 'react';
import { DepositForm } from './components/DepositForm/DepositForm';
import { TransferModal, TabType } from '../TransferModal/TransferModal';
import { DepositMetadata, useDepositForm } from './components/DepositForm/useDepositForm';
import { LoadingModal } from '../LoadingModal/LoadingModal';
import { ErrorModal } from '../ErrorModal/ErrorModal';
import { DepositParams } from '../../api/useDepositMutation';
import { DepositPreview } from './DepositPreview';

interface Props {
  onClose(): void;
  onBack(): void;
}

export const Deposit: React.FC<Props> = ({ onClose, onBack }) => {
  const { isLoading, isError, refetch } = useDepositForm();

  const [depositDetails, setDepositDetails] = useState<{
    params: DepositParams;
    metadata: DepositMetadata;
  } | null>(null);

  if (isLoading) {
    return <LoadingModal />;
  }

  if (isError) {
    return <ErrorModal onClose={onClose} onRetry={refetch} />;
  }

  return (
    <TransferModal tab={TabType.Deposit} onClose={onClose} onBack={onBack}>
      {props =>
        depositDetails ? (
          <DepositPreview
            {...props}
            depositDetails={depositDetails}
            onBack={() => setDepositDetails(null)}
          />
        ) : (
          <DepositForm {...props} onSuccess={setDepositDetails} />
        )
      }
    </TransferModal>
  );
};
